import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { QRCodeSVG } from 'qrcode.react';
import { CopyTextButton } from '../CopyTextButton';
import Modal from '../Modal';
import styles from './TwoFactorSetupModal.module.scss';
import { Divider, Text } from '@mantine/core';
export default function TwoFactorSetupModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onComplete = param.onComplete, twoFactorUrl = param.twoFactorUrl, twoFactorSecret = param.twoFactorSecret;
    var intl = useIntl();
    if (twoFactorUrl == null || twoFactorSecret == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Modal, {
        title: intl.formatMessage({
            id: "Uvebfs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Setup Two-Factor Authentication"
                }
            ]
        }),
        isOpen: isOpen,
        onClose: onClose,
        onConfirm: function() {
            onClose();
            onComplete();
        },
        confirmText: intl.formatMessage({
            id: "q5Xl0M",
            defaultMessage: [
                {
                    type: 0,
                    value: "Verify"
                }
            ]
        }),
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.modalDescription,
                children: [
                    /*#__PURE__*/ _jsx(QRCodeSVG, {
                        value: twoFactorUrl,
                        size: 128,
                        className: styles.qrCode
                    }),
                    /*#__PURE__*/ _jsx(CopyTextButton, {
                        value: twoFactorSecret
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        size: "sm",
                        className: styles.disclaimer,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "WrQRqu",
                            defaultMessage: "Scan the QR code above with your authenticator app to enable two-factor authentication, or manually enter the code."
                        })
                    })
                ]
            })
        ]
    });
}
